export default {
  default: () => import("/Users/klemen/Desktop/Development/kroznik/monorepo/kroznik_backoffice/layouts/default.vue").then(m => m.default || m),
  public: () => import("/Users/klemen/Desktop/Development/kroznik/monorepo/kroznik_backoffice/layouts/public.vue").then(m => m.default || m)
}